import { useApi } from '@/api/useApi'
import API from '@/api/apiUrls'
import { useGiDataUploadCollectionStore } from '@/stores/giDataUploadCollection'
import { useTaskPolling, type TaskProgress } from '@haskoning/vue-speckle'
import type { GiDataUploadCollectionType } from '@/stores/type/giPoint.type'

const api = useApi<any>()

export type ImportProgress = TaskProgress

export function useGIDataSpeckleImport() {
	const giDataUploadCollectionStore = useGiDataUploadCollectionStore()

	const {
		progress: importProgress,
		start: startPolling,
		stop: stopPolling
	} = useTaskPolling((taskId) =>
		api.service(API.GI_DATA_UPLOAD_COLLECTIONS.TASK_STATUS(taskId)).get()
	)

	function applyImportedCollection(collection: GiDataUploadCollectionType) {
		giDataUploadCollectionStore.items.push(collection)
		giDataUploadCollectionStore.updateGiPoints(collection)
	}

	async function importGIData(data: Record<string, any>) {
		const response = await api
			.service(API.GI_DATA_UPLOAD_COLLECTIONS.IMPORT_FROM_SPECKLE)
			.create(data)

		if (!response?.task_id) {
			applyImportedCollection(response)
			return response
		}

		try {
			const collection = await startPolling(response.task_id)
			applyImportedCollection(collection)
			return collection
		} finally {
			stopPolling()
		}
	}

	return { importGIData, importProgress }
}
